import { PurchaseOrder, PurchaseOrderProduct } from "../../../models/purchase.order";

export const convertPurchaseOrdersToPurchaseOrdersProducts = (purchaseOrders: PurchaseOrder[]) => {
  let data: PurchaseOrderProduct[] = [];

  for (const purchaseOrder of purchaseOrders) {
    const eachPurchaseOrder = (purchaseOrder.purchaseOrderProducts || []).map(
      (purchaseOrderProduct) =>
        ({
          ...purchaseOrderProduct,
          product: purchaseOrderProduct.product,
          purchaseOrder,
        } as PurchaseOrderProduct)
    );

    data = [...data, ...eachPurchaseOrder];
  }

  return data;
};
